import * as React from 'react'

import Box from '@mui/material/Box'
import FormHelperText from '@mui/material/FormHelperText'
import { Select } from '@workwave-tidal/core/components'

import { useData } from './hooks/useData'
import { useHandlers } from './hooks/useHandlers'
import { IDiscountCode } from '@user/store/discountCode/typings'

type Props = {
  code?: string
  label?: string
  onChange?: (discountId: string, discountCode: string) => void
  salesTeamId: string
}

export function TidalDiscountCodeSelect(props: Props) {
  const { label = 'Discount Code', onChange, salesTeamId } = props

  const {
    description,
    discountCodes,
    discountDisabled,
    setValue,
    status,
    getOptionLabel,
    value,
    getId,
    density,
  } = useData(props)

  const { handleTidalChange } = useHandlers({
    discountCodes,
    setValue,
    onChange,
  })

  return (
    <>
      <Select<IDiscountCode>
        disabled={discountDisabled}
        placeholder={status === 'pending' ? 'Loading...' : undefined}
        getLabel={getOptionLabel}
        getId={getId}
        items={discountCodes}
        onChange={handleTidalChange}
        value={value}
        label={label}
        optionMode={'normal'}
        density={density}
        data-test-id="discount-code-select"
      />
      {description && (
        <FormHelperText>
          <Box ml={2} component="span">
            Discount Details:
          </Box>{' '}
          {description}
        </FormHelperText>
      )}
      {!salesTeamId && (
        <FormHelperText error>
          Select a Sales Team to see a list of available referral discount
          codes.
        </FormHelperText>
      )}
    </>
  )
}
